module.exports = () =>
    ({
        restrict: 'C',
        scope: {
            theme: '<'
        },
        templateUrl: '/static/partials/apps/components/event-list-preview.html'
    });
